import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useRoles } from "../context/RolesContext";
import { PageHeader } from "../components/ui-kit";
import { TaskList } from "../components/TaskList";

export function Queue() {
  const { user } = useAuth();
  const { roles: all, roleMap } = useRoles();
  const roles = user.is_admin ? all.map((r) => r.key) : user.roles;
  const [role, setRole] = useState("all");
  return (
    <div>
      <PageHeader eyebrow="Shared queue" title="Up for grabs" desc="Work waiting for your role(s). Anyone with the role can pick it up — first come, first served." />
      <div className="mb-6 flex flex-wrap gap-2">
        {["all", ...roles].map((r) => (
          <button key={r} data-testid={`queue-filter-${r}`} onClick={() => setRole(r)}
            className={`rounded-full border px-4 py-1.5 text-xs font-medium transition-colors ${role === r ? "border-[#FF6B00] bg-[#FF6B00] text-white" : "border-[#282E3D] text-slate-400 hover:text-white"}`}>
            {r === "all" ? "All my roles" : roleMap[r]?.label || r}
          </button>
        ))}
      </div>
      {!user.is_admin && !user.roles.length ? (
        <div data-testid="no-roles-notice" className="rounded-xl border border-amber-500/30 bg-amber-500/10 p-5 text-sm text-amber-200">You don't have any roles yet. Ask the admin to assign one.</div>
      ) : (
        <TaskList scope="queue" filter={(t) => role === "all" || t.current_role === role} emptyTitle="Queue is clear" emptyDesc="Nothing is waiting for your role right now." />
      )}
    </div>
  );
}

export function MyTasks() {
  return (
    <div>
      <PageHeader eyebrow="My desk" title="My tasks" desc="Work you've picked up. Finish the step, or send it back with comments." />
      <TaskList scope="mine" emptyTitle="Your desk is empty" emptyDesc="Pick something up from the shared queue." />
    </div>
  );
}

export function Done() {
  return (
    <div>
      <PageHeader eyebrow="My history" title="Steps I've done" desc="Every work item where you completed at least one step." />
      <TaskList scope="done" emptyTitle="No history yet" emptyDesc="Completed steps will show up here." />
    </div>
  );
}
